module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_1-2d34801871fbaec264c326048a2632e4.png";